import languageDic from '@/assets/languages.json'

export function formatSpokenLanguages(languages: string[]): string {
  return languages
    .map(l => languageDic.find(l2 => l2.code == l).frenchName)
    .join(', ')
}
